import { useContext } from 'react';
import { rSimsSimsContext } from 'rSimInventory/Components/Providers/RSimsSimsContext';

export const useRSimsSimsContext = () => {
  return useContext(rSimsSimsContext);
};
